import {
    createSelector,
    Selector,
} from '@reduxjs/toolkit';

import {EEntityType} from 'shared/constants/entities';
import {TAppState} from 'store/config/types';

import {METADATA_MODULE} from './metadata-constants';
import {
    IMetadataState,
} from './metadata-types';

const rootSelector: Selector<TAppState, IMetadataState> = (state: TAppState) => state[METADATA_MODULE];

export const selectMetadata = (entityName: string, entityType: EEntityType) => createSelector(
    rootSelector,
    (metadataState: IMetadataState) => metadataState[entityName]?.[entityType],
);

export const selectEntityMetadata = (entityName: string) => createSelector(
    rootSelector,
    (metadataState: IMetadataState) => metadataState[entityName],
);

export const selectTableEntityMetadata = (entityName: string) => createSelector(
    rootSelector,
    (metadataState: IMetadataState) => metadataState[entityName]?.[EEntityType.TABLE],
);

export const selectFilterEntityMetadata = (entityName: string) => createSelector(
    rootSelector,
    (metadataState: IMetadataState) => metadataState[entityName]?.[EEntityType.FILTER],
);

export const selectFormEntityMetadata = (entityName: string) => createSelector(
    rootSelector,
    (metadataState: IMetadataState) => metadataState[entityName]?.[EEntityType.FORM],
);
export const selectFormDraftMetadata = (entityName: string) => createSelector(
    rootSelector,
    (metadataState: IMetadataState) => metadataState[entityName]?.[EEntityType.FORM]?.isDraft,
);
